/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL3RyaWFnZS1jb21wb25lbnRzL3RyaWFnZS1xdWVzdGlvbnMvdHJpYWdlLXF1ZXN0aW9uLWZyZWUtdGV4dC90cmlhZ2UtcXVlc3Rpb24tZnJlZS10ZXh0LmNvbXBvbmVudC5jc3MifQ== */"];
export { styles as styles };
